<template>
  <div id="page-wrapper">
    <div id="header2">
      <!-- Nav -->
      <nav id="nav">
        <img
          class="imagetran"
          src="https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/36571d0c027841b6a16ad96fa941f355.png"
          alt=""
          @click="goLink('Home')"
        />
        <ul>
          <li
            :class="currentRouteName == 'Home' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'Home' ? '100%' : '0',
            }"
          >
            <router-link to="/">
              <a> 首页</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'policy' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'policy' ? '100%' : '0',
            }"
          >
            <router-link to="/policy">
              <a>政策法规</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'vipBox' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'vipBox' ? '100%' : '0',
            }"
          >
            <router-link to="/vipBox">
              <a>会员单位</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'newBox' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'newBox' ? '100%' : '0',
            }"
          >
            <router-link to="/newBox">
              <a>新闻动态</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'contact' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'contact' ? '100%' : '0',
            }"
          >
            <router-link to="/contact">
              <a> 联系我们</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'About' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'About' ? '100%' : '0',
            }"
          >
            <router-link to="/About">
              <a>关于协会</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'signUp' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'signUp' ? '100%' : '0',
            }"
          >
            <router-link to="/signUp">
              <a> 护工培训</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'zhaogong' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'zhaogong' ? '100%' : '0',
            }"
          >
            <router-link to="/zhaogong">
              <a> 招工需求</a>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
    <template>
      <div class="imageBox" :style="{ backgroundImage: `url(${image})` }">
        <div class="p1 animate__animated animate__zoomIn">详情</div>
        <div class="p2 animate__animated animate__zoomIn">
          <span class="p3" style="cursor: pointer" @click="goDetails('Home')"
            >首页</span
          >
          <span> > </span>
          <span class="p4" style="cursor: pointer" @click="goDetails(router)">
            {{ name }}</span
          >
        </div>
      </div>
    </template>

    <div class="new_main_box">
      <p class="p1">{{ datails.title }}</p>
      <div class="image-container ql-editor" v-html="datails.content"></div>
    </div>

    <About></About>
  </div>
</template>
      
      
      <script>
import "../assets/css/main.css";
import "../assets/css/noscript.css";
import { newsList, newsView } from "../api/index";
import About from "./Footer.vue";
export default {
  name: "Home",
  components: {
    // 注册组件
    About,
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      list: [],
      type: 7,
      currentRouteName: "",
      datails: {},
      id: null,
      name: "",
      image: "",
    };
  },
  created() {
    console.log(789456, this.$route.query);
    this.id = this.$route.query.id;
    this.name = this.$route.query.name;
    this.image = this.$route.query.image;
    this.router = this.$route.query.router;
    this.get_new_view(this.id);
  },
  methods: {
    goLink(name) {
      this.$router.push({
        name: name,
      });
    },
    goDetails(name, id) {
      this.$router.push({
        name: name,
        query: {
          id: id,
        },
      });
    },
    isActive(path) {
      console.log(path, this.$route.path);
      return this.$route.path === path;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.get_newsList(this.type);
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.get_newsList(this.type);
    },
    handlePrevClick() {
      this.pageNum--;
      this.get_newsList(this.type);
    },
    handleNextClick() {
      this.pageNum++;
      this.get_newsList(this.type);
    },
    get_newsList(type) {
      this.type = type;
      const params = {
        accId: 1,
        newType: type, //行业资讯,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      console.log(999, params);
      newsList(params, this.pageNum, this.pageSize).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.list = res.dataMap.list;
          this.get_new_view(this.list[0].id);
          this.total = res.dataMap.total;
        } else {
          this.$message(res.message);
        }
      });
    },
    get_new_view(id) {
      const params = { id: id };
      newsView(params).then((res) => {
        this.datails = res.dataMap;
        console.log(11111, this.datails);
      });
    },
  },
  mounted() {
    this.currentRouteName = this.$route.name;
    console.log(741, this.currentRouteName);
    // this.get_newsList(7);
  },
};
</script>
      
    <style scoped>
html {
  font-size: 20px;
}

.image-container {
  text-align: center; /* 对于行内元素或行内块级元素居中 */
  text-indent: 2em;
}

/deep/ .image-container img {
  display: block; /* 将图片转换为块级元素 */
  max-width: 100% !important;
  height: auto !important;
  margin: 0 auto; /* 左右外边距自动，实现水平居中 */
}

.el-pagination {
  float: none !important;
  font-size: 20px !important;
}

.active {
  color: #0ba29a !important;
  font-weight: 600;
}

.linkactive {
  color: #0ba29a !important;
  font-weight: 600;
}

.active1 {
  color: #ffffff;
}

.imageBox {
  background-image: url("https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/4dfd00e08ae5452abd868b3f22fc61fe.png");
  background-size: 100% 100%;
  color: #fff;
  padding: 12em 18em 12em 18em;
  cursor: default;
  height: 560px;
  text-align: left;
}

.imageBox .p1 {
  font-family: OPPOSans;
  font-weight: 400;
  font-size: 3em;
  color: #222222;
  margin-bottom: 50px;
}

.imageBox .p2 {
  font-family: OPPOSans;
  font-weight: 400;
  font-size: 1.5em;
  color: #222222;
}

.imageBox .p3 {
  cursor: pointer;
}

.imageBox .p3:hover {
  color: #097c76;
}

.imageBox .p4:hover {
  color: #097c76;
}

.new_main_box {
  padding: 2.5em 18em;
}

.new_main_box .p1 {
  text-align: center;
  font-size: 1.5em;
  font-weight: 600;
}

.new_top_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.new_top_flex {
  width: 29.4em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.new_top_flex .image {
  max-width: 100%;
  height: auto;
}

.new_top_flex .btn {
  position: relative;
  display: inline-block;
  background: #0ba29a;
  color: #fff;
  text-align: center;
  /* border-radius: 0.5em; */
  text-decoration: none;
  padding: 0.65em 3em 0.65em 3em;
  border: 0;
  cursor: pointer;
  outline: 0;
  font-weight: 300;
  width: 200px;
  -moz-transition: background-color 0.35s ease-in-out, color 0.35s ease-in-out,
    border-bottom-color 0.35s ease-in-out;
  -webkit-transition: background-color 0.35s ease-in-out,
    color 0.35s ease-in-out, border-bottom-color 0.35s ease-in-out;
  -ms-transition: background-color 0.35s ease-in-out, color 0.35s ease-in-out,
    border-bottom-color 0.35s ease-in-out;
  transition: background-color 0.35s ease-in-out, color 0.35s ease-in-out,
    border-bottom-color 0.35s ease-in-out;
}

.new_top_flex .btn:hover {
  color: #fff;
  background: #097c76;
}

.new_top_flex .p1 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 1.3em;
  color: #333333;
}

.new_top_flex .p2 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.8em;
  color: #333333;
}

.new_top_flex .btn {
  margin-top: 30px;
}

.bottomBox {
  width: 100%;
  margin-top: 40px;
}

.bottom_flex {
  width: 100%;
  padding: 2.12em 0;
  display: flex;
  justify-content: start;
}

.bottom_img {
  width: 12em;
  height: 7.5em;
  margin-right: 1.995em;
}
.bottom_img .image {
  width: 12em;
  height: 7.5em;
}

.bottom_text {
  width: 61.81em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}

.bottom_text .p1 {
  font-family: PingFang SC;
  font-size: 1.3em;
  color: #333333;
  font-weight: 800;
}

.bottom_text .p1:hover {
  color: #097c76;
  cursor: pointer;
}
.bottom_text .p2 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.8em;
  color: #666666;
}

.bottom_text .p2:hover {
  color: #097c76;
  cursor: pointer;
}

.bottom_text_bottom {
  display: flex;
  justify-content: space-between;
}
.bottom_text_bottom .image {
  width: 1.333em;
  height: 1.333em;
}
.bottom_text_bottom .p3 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.7em;
  color: #666666;
}

.bannerBox2 {
  background-color: #ffffff;
}

.bannerBox2 > ul {
  line-height: 80px;
  position: relative;
  display: inline-block;
  margin: 0;
  height: 80px;
  line-height: 80px;
  display: flex;
  justify-content: center;
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  cursor: pointer;
}

.bannerBox2 > ul:after {
  right: 100%;
  margin-right: 1px;
}

.bannerBox2 > ul > li {
  display: inline-block;
  margin: 0px 2em 0 2em;
  border: solid 1px transparent;
  -moz-transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  -webkit-transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  -ms-transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  color: #333;
}

.bannerBox2 > ul > li > a,
.bannerBox2 > ul > li > span {
  display: block;
  color: inherit;
  text-decoration: none;
  border: 0;
  outline: 0;
}

.bannerBox2 > ul > li > a {
  display: block;
  color: #222222;
  text-align: center;
  text-decoration: none;
  position: relative;
}

.bannerBox2 > ul > li > a::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 4px;
  background-color: #0ba29a;
  color: #0ba29a;
  transition: width 0.1s ease;
}

.bannerBox2 > ul > li > a:hover::after {
  width: 100%;
}

.bannerBox2 > ul > li > a:hover {
  color: #0ba29a;
  font-weight: 600;
}

.bannerBox2 > ul > li > a.current-page {
  color: #0ba29a;
  font-weight: 600;
}

.bannerBox2 > ul > li > ul {
  display: none;
}

@media screen and (max-width: 1680px) {
  .imageBox {
    padding: 12em 10em 12em 10em;
  }
  .new_main_box {
    padding: 3em 10em;
  }
}

@media screen and (max-width: 1280px) {
  .image-container img {
    max-width: 70% !important;
    height: auto;
  }

  .imageBox {
    padding: 12em 10em 12em 10em;
  }
  .new_main_box {
    padding: 3em 10em;
  }
}

@media screen and (max-width: 960px) {
  .image-container img {
    max-width: 50% !important;
    height: auto;
  }
}

@media screen and (max-width: 840px) {
  html {
    font-size: 10px;
  }

  .imageBox {
    background-image: url("https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/9434bb03a43a47269d439666993d569b.png");
    background-size: 100% 100%;
    color: #fff;
    padding: 12em 60px 12em 60px;
    cursor: default;
    height: 560px;
    text-align: center;
    line-height: 40px;
  }

  .new_top_box {
    flex-direction: column;
  }

  .new_top_flex:nth-child(1) {
    width: 100%;
    order: 2;
  }

  .new_top_flex:nth-child(2) {
    width: 100%;
    order: 1;
    margin-bottom: 20px;
  }

  .new_main_box {
    padding: 1em;
    background-color: #ffffff !important;
  }

  .new_top_flex .p1 {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 30px;
    color: #0ba29a;
  }

  .new_top_flex .p2 {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #434343;
  }

  .new_top_flex .shareBox {
    display: inline-block;
  }

  .new_top_flex .shareBox .image {
    width: 15em;
    height: 15em;
    text-align: center;
    display: block;
    margin: 0 auto;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 736px) {
  html {
    font-size: 10px;
  }

  .imageBox {
    background-image: url("https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/9434bb03a43a47269d439666993d569b.png");
    background-size: 100% 100%;
    color: #fff;
    padding: 12em 60px 12em 60px;
    cursor: default;
    height: 560px;
    text-align: center;
    line-height: 40px;
  }

  .new_top_box {
    flex-direction: column;
  }

  .new_top_flex:nth-child(1) {
    width: 100%;
    order: 2;
  }

  .new_top_flex:nth-child(2) {
    width: 100%;
    order: 1;
    margin-bottom: 20px;
  }

  .new_main_box {
    padding: 1em;
  }

  .new_top_flex .p1 {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 30px;
    color: #0ba29a;
  }

  .new_top_flex .p2 {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #434343;
  }

  .new_top_flex .shareBox .image {
    width: 15em;
    height: 15em;
    text-align: center;
    display: block;
    margin: 0 auto;
    margin-bottom: 20px;
  }

  .image-container img {
    max-width: 736px !important;
    height: auto;
  }

  .ql-indent-1 {
    padding-left: 0px !important;
    text-indent: 1em !important;
  }

  .ql-indent-2 {
    padding-left: 0px !important;
    text-indent: 2em !important;
  }

  .ql-indent-3 {
    padding-left: 0px !important;
    text-indent: 3em !important;
  }

  .ql-indent-4 {
    padding-left: 0px !important;
    text-indent: 4em !important;
  }

  .ql-indent-5 {
    padding-left: 0px !important;
    text-indent: 5em !important;
  }

  .ql-indent-6 {
    padding-left: 0px !important;
    text-indent: 6em !important;
  }

  .ql-indent-7 {
    padding-left: 0px !important;
    text-indent: 7em !important;
  }

  .ql-indent-8 {
    padding-left: 0px !important;
    text-indent: 8em !important;
  }
}
</style>
      
      